export default __webpack_public_path__ + "static/media/CIA-2024-Brochures.d81feef1.pdf";